export default __webpack_public_path__ + "static/media/bg_big_red.989cfe13.svg";